import React from 'react'

interface FAQSectionProps {
  children: React.ReactNode
}

const FAQSection: React.FC<FAQSectionProps> = ({ children }) => {
  return (
    <aside className="flex w-full flex-col gap-6 rounded-2xl lg:border lg:border-gray-300 lg:p-6">
      <h3 className="text-xl font-medium text-gray-1100 lg:text-lg">
        Frequently Asked Questions
      </h3>
      <div className="flex flex-col gap-4">{children}</div>
    </aside>
  )
}

export default FAQSection
